export function patchGoogleMapsDebug() {
  const globalWindow = window as Window & {
    google?: { maps?: any }
    __mapsDebugPatched?: boolean
  }

  // Keep this utility opt-in. Runtime monkey patching of Google Maps internals
  // can break browser-specific implementations (notably Safari/WebKit).
  let storageEnabled = false
  let queryEnabled = false

  try {
    storageEnabled = localStorage.getItem('mapsDebug') === '1'
  } catch {
    storageEnabled = false
  }

  try {
    queryEnabled =
      new URLSearchParams(window.location.search).get('mapsDebug') === '1'
  } catch {
    queryEnabled = false
  }

  const shouldEnable = storageEnabled || queryEnabled

  if (!shouldEnable) {
    return
  }

  if (!globalWindow.google?.maps) {
    console.warn('[Maps Debug] Google Maps not loaded')
    return
  }

  if (globalWindow.__mapsDebugPatched) {
    return
  }

  const gmaps = globalWindow.google.maps

  // Patch selected methods only; avoid replacing constructors/classes.
  const methodsToPatch = [
    ['Geocoder', 'geocode'],
    ['DirectionsService', 'route'],
    ['DistanceMatrixService', 'getDistanceMatrix'],
    ['PlacesService', 'findPlaceFromQuery'],
    ['PlacesService', 'nearbySearch'],
    ['PlacesService', 'textSearch'],
    ['PlacesService', 'getDetails'],
    ['AutocompleteService', 'getPlacePredictions'],
    ['ElevationService', 'getElevationForLocations'],
  ]

  methodsToPatch.forEach(([className, methodName]) => {
    const ClassRef = gmaps[className]
    if (ClassRef?.prototype?.[methodName]) {
      const originalMethod = ClassRef.prototype[methodName]
      if (originalMethod.__mapsDebugWrapped) {
        return
      }

      try {
        const wrapped = function (this: unknown, ...args: any[]) {
          console.debug(`[Maps Debug] ${className}.${methodName} called`, args)
          return originalMethod.apply(this, args)
        }
        ;(wrapped as any).__mapsDebugWrapped = true
        ClassRef.prototype[methodName] = wrapped
      } catch {
        // Ignore non-writable members from Google Maps internals.
      }
    }
  })

  globalWindow.__mapsDebugPatched = true
  console.debug('[Maps Debug] Patching done')
}
